import { proxy } from "valtio";
import { LovewallSubscription } from "../types/subscription";

export const subscriptionStore = proxy<
{
  data: LovewallSubscription | null;
}>(
  {
    data: null,
  }
);
